
import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import assetReducer from './assetSlice';
import mfaReducer from './mfaSlice';

const store = configureStore({
  reducer: {
    user: userReducer,
    assets: assetReducer,
  mfa: mfaReducer,
  },
});

export default store;
